var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticClass: "report-dashboard requests-dashboard py-0",
      attrs: { fluid: "" }
    },
    [
      _c("DashboardFilters", { on: { input: _vm.setCriteria } }),
      _c("v-progress-linear", {
        attrs: { active: _vm.loading, color: "secondary", indeterminate: "" }
      }),
      _vm.dashboard
        ? _c(
            "div",
            {
              staticClass: "dashboard-content",
              style: { height: _vm.contentHeight }
            },
            [
              _c("div", { staticClass: "section-title" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("labels.mixAndOutcomes")) +
                    "\n    "
                )
              ]),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                _vm._l(_vm.overviewTiles, function(tile) {
                  return _c(
                    "v-col",
                    { key: tile.key, attrs: { cols: "6", md: "3" } },
                    [
                      _c("DashboardTile", {
                        class: tile.key,
                        attrs: {
                          detail: tile.detail,
                          label: tile.label,
                          value: tile.value
                        }
                      })
                    ],
                    1
                  )
                }),
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "8" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "chart-card", attrs: { outlined: "" } },
                        [
                          _c("div", { staticClass: "chart-title" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("labels.requestsPerDay")) +
                                "\n          "
                            )
                          ]),
                          _c("BarChart", {
                            attrs: {
                              "chart-data": _vm.requestsPerDayData,
                              options: _vm.stackedBarOptions,
                              styles: _vm.chartStyles
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "chart-card request-types",
                          attrs: { outlined: "" }
                        },
                        [
                          _c("div", { staticClass: "chart-title" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("labels.requestTypes")) +
                                "\n          "
                            )
                          ]),
                          _vm.dashboard.requests > 0
                            ? _c("DoughnutChart", {
                                attrs: {
                                  "chart-data": _vm.typeMixData,
                                  options: _vm.doughnutOptions,
                                  styles: _vm.chartStyles
                                }
                              })
                            : _c(
                                "div",
                                {
                                  staticClass: "no-data grey--text",
                                  style: _vm.chartStyles
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$t("labels.noRecords")) +
                                      "\n          "
                                  )
                                ]
                              )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "chart-card outcomes",
                          attrs: { outlined: "" }
                        },
                        [
                          _c("div", { staticClass: "chart-title" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("labels.outcomes")) +
                                "\n          "
                            )
                          ]),
                          _vm.dashboard.requests > 0
                            ? _c("DoughnutChart", {
                                attrs: {
                                  "chart-data": _vm.outcomesData,
                                  options: _vm.doughnutOptions,
                                  styles: _vm.chartStyles
                                }
                              })
                            : _c(
                                "div",
                                {
                                  staticClass: "no-data grey--text",
                                  style: _vm.chartStyles
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$t("labels.noRecords")) +
                                      "\n          "
                                  )
                                ]
                              )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "8" } },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "chart-card event-types",
                          attrs: { outlined: "" }
                        },
                        [
                          _c("div", { staticClass: "chart-title" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("labels.eventRequestsByType")) +
                                "\n          "
                            )
                          ]),
                          _vm.dashboard.byEventType.length > 0
                            ? _c("HorizontalBarChart", {
                                attrs: {
                                  "chart-data": _vm.eventTypesData,
                                  options: _vm.horizontalBarOptions,
                                  styles: _vm.barChartStyles(
                                    _vm.dashboard.byEventType.length
                                  )
                                }
                              })
                            : _c(
                                "div",
                                {
                                  staticClass: "no-data grey--text",
                                  style: _vm.chartStyles
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$t("labels.noRecords")) +
                                      "\n          "
                                  )
                                ]
                              )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("div", { staticClass: "section-title" }, [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("labels.mostRequests")) + "\n    "
                )
              ]),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "chart-card", attrs: { outlined: "" } },
                        [
                          _vm.dashboard.topShare.staff > 0
                            ? _c(
                                "div",
                                { staticClass: "top-share body-2 mb-2" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$t("labels.topRequestersShare", {
                                          percent: _vm.formatNumber(
                                            _vm.dashboard.topShare.percent
                                          ),
                                          staff: _vm.formatNumber(
                                            _vm.dashboard.topShare.staff
                                          )
                                        })
                                      ) +
                                      "\n          "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "v-simple-table",
                            {
                              staticClass: "top-requesters",
                              attrs: { dense: "" }
                            },
                            [
                              _c("thead", [
                                _c("tr", [
                                  _c("th", [
                                    _vm._v(
                                      _vm._s(_vm.$t("labels.employeeName"))
                                    )
                                  ]),
                                  _c("th", [
                                    _vm._v(
                                      _vm._s(_vm.$t("labels.homeDepartment"))
                                    )
                                  ]),
                                  _c("th", { staticClass: "text-right" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("labels.total")) +
                                        "\n                "
                                    )
                                  ]),
                                  _c("th", [
                                    _vm._v(_vm._s(_vm.$tc("labels.request", 2)))
                                  ]),
                                  _c("th", { staticClass: "text-right" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("labels.approved")) +
                                        "\n                "
                                    )
                                  ]),
                                  _c("th", { staticClass: "text-right" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("labels.rejected")) +
                                        "\n                "
                                    )
                                  ]),
                                  _c("th", { staticClass: "text-right" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("labels.withdrawn")) +
                                        "\n                "
                                    )
                                  ]),
                                  _c("th", { staticClass: "text-right" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("labels.approvalRate")) +
                                        "\n                "
                                    )
                                  ])
                                ])
                              ]),
                              _c(
                                "tbody",
                                [
                                  _vm._l(_vm.dashboard.topRequesters, function(
                                    row
                                  ) {
                                    return _c("tr", { key: row.userId }, [
                                      _c("td", [_vm._v(_vm._s(row.name))]),
                                      _c("td", [
                                        _vm._v(_vm._s(row.homeDepartmentName))
                                      ]),
                                      _c("td", { staticClass: "text-right" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.formatNumber(row.total)
                                            ) +
                                            "\n                "
                                        )
                                      ]),
                                      _c(
                                        "td",
                                        _vm._l(
                                          _vm.sortedTypes(row.byType),
                                          function(type) {
                                            return _c(
                                              "v-chip",
                                              {
                                                key: type,
                                                staticClass: "mr-1",
                                                attrs: {
                                                  color: _vm.typeColor(type),
                                                  "text-color": "white",
                                                  "x-small": ""
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.typeLabel(type)
                                                    ) +
                                                    " " +
                                                    _vm._s(row.byType[type]) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                      _c("td", { staticClass: "text-right" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.formatNumber(row.approved)
                                            ) +
                                            "\n                "
                                        )
                                      ]),
                                      _c("td", { staticClass: "text-right" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.formatNumber(row.rejected)
                                            ) +
                                            "\n                "
                                        )
                                      ]),
                                      _c("td", { staticClass: "text-right" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.formatNumber(row.withdrawn)
                                            ) +
                                            "\n                "
                                        )
                                      ]),
                                      _c("td", { staticClass: "text-right" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.formatPercent(
                                                row.approvalRate
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ])
                                    ])
                                  }),
                                  _vm.dashboard.topRequesters.length === 0
                                    ? _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "grey--text",
                                            attrs: { colspan: "8" }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t("labels.noRequests")
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      ])
                                    : _vm._e()
                                ],
                                2
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("div", { staticClass: "section-title" }, [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("labels.patterns")) + "\n    "
                )
              ]),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "chart-card", attrs: { outlined: "" } },
                        [
                          _c("div", { staticClass: "chart-title" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("labels.requestedDaysByWeekday")
                                ) +
                                "\n          "
                            )
                          ]),
                          _c("BarChart", {
                            attrs: {
                              "chart-data": _vm.weekdayData,
                              options: _vm.barOptions,
                              styles: _vm.chartStyles
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "chart-card", attrs: { outlined: "" } },
                        [
                          _c("div", { staticClass: "chart-title" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("labels.requestLeadTime")) +
                                "\n          "
                            )
                          ]),
                          _c("BarChart", {
                            attrs: {
                              "chart-data": _vm.leadTimeData,
                              options: _vm.barOptions,
                              styles: _vm.chartStyles
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("div", { staticClass: "section-title" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("labels.speedAndTiming")) +
                    "\n    "
                )
              ]),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _vm._l(_vm.timingTiles, function(tile) {
                    return _c(
                      "v-col",
                      { key: tile.key, attrs: { cols: "6", md: "3" } },
                      [
                        _c("DashboardTile", {
                          class: tile.key,
                          attrs: {
                            detail: tile.detail,
                            label: tile.label,
                            value: tile.value
                          }
                        })
                      ],
                      1
                    )
                  }),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "chart-card", attrs: { outlined: "" } },
                        [
                          _c("div", { staticClass: "chart-title" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("labels.medianTurnaroundByType")
                                ) +
                                "\n          "
                            )
                          ]),
                          _c("BarChart", {
                            attrs: {
                              "chart-data": _vm.turnaroundByTypeData,
                              options: _vm.barOptions,
                              styles: _vm.chartStyles
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }